import {Module} from "vuex-smart-module";

import WarehouseShopState from "@/store/modules/warehouse-shop/warehouse-shop-state";
import WarehouseShopGetters from "@/store/modules/warehouse-shop/warehouse-shop-getters";
import WarehouseShopMutations from "@/store/modules/warehouse-shop/warehouse-shop-mutations";
import WarehouseShopActions from "@/store/modules/warehouse-shop/warehouse-shop-actions";

export default new Module({
    state: WarehouseShopState,
    getters: WarehouseShopGetters,
    mutations: WarehouseShopMutations,
    actions: WarehouseShopActions
});